import Backend from "./backend";
import LocalStorage from "./localStorage";

const API = {
    Backend,
    LocalStorage
};

export default API;
